var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWrong = function SvgWrong(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4294",
    "data-name": "Group 4294",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48089",
    "data-name": "Path 48089",
    d: "M937.094,295.224a13,13,0,1,1-13,13,13,13,0,0,1,13-13Zm0,1.872a11.128,11.128,0,1,0,11.128,11.128A11.128,11.128,0,0,0,937.094,297.1Z",
    transform: "translate(-924.094 -295.224)",
    fill: "#ca2c29",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48090",
    "data-name": "Path 48090",
    d: "M1097.216,456.591h0a.942.942,0,0,0-1.322.019l-4.4,4.414-4.4-4.414a.942.942,0,0,0-1.322-.019h0a.933.933,0,0,0-.019,1.322l4.421,4.435-4.421,4.435a.933.933,0,0,0,.019,1.322h0a.942.942,0,0,0,1.322-.019l4.4-4.414,4.4,4.414a.942.942,0,0,0,1.322.019h0a.933.933,0,0,0,.019-1.322l-4.421-4.435,4.421-4.435A.933.933,0,0,0,1097.216,456.591Z",
    transform: "translate(-1078.494 -449.348)",
    fill: "#ca2c29",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWrong, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wrong.67d1a2aa.svg";
export { ForwardRef as ReactComponent };